import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import Icon from '@ucheba/ui/icons/icon__check_circle-outline.svg'
import { ILearningOutcomes } from '../types'

const LearningOutcomes: FC<ILearningOutcomes> = (props) => {
  const { list } = props

  return (
    <div>
      <Heading h3='Результаты обучения' spacing='small' />

      <List spacing='xsmall'>
        {list.map((item, key) => (
          <ListItem
            key={key}
            StartIcon={<Icon width='20px' height='20px' color='blue' />}
          >
            {item.text}
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default LearningOutcomes
